import { useQuery } from '@apollo/client'
import { UseNewAdditionalCompensationsFeatureEnabledDocument } from 'generated/resources/graphql'

type UseNewAdditionalCompensationsFeatureEnabledProps = {
  companyId: number
}
function useNewAdditionalCompensationsFeatureEnabled({
  companyId,
}: UseNewAdditionalCompensationsFeatureEnabledProps) {
  const {
    data: newAdditionalCompensationsFeatureEnabledData,
    error,
    loading,
  } = useQuery(UseNewAdditionalCompensationsFeatureEnabledDocument, { variables: { companyId } })

  const isNewAdditionalCompensationsSupportEnabled =
    error || loading
      ? false
      : newAdditionalCompensationsFeatureEnabledData?.features?.featuresConnection?.nodes?.[0]
          ?.enabled

  return isNewAdditionalCompensationsSupportEnabled
}

export { useNewAdditionalCompensationsFeatureEnabled }
